import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BillingStatus } from '../../types';
import './BillingStatusLegendTooltip.css';

const BILLING_LEGEND_STATUSES: BillingStatus[] = [
  BillingStatus.TO_VALIDATE,
  BillingStatus.VALIDATED,
  BillingStatus.INVOICED,
];

/** Home Finance: legenda del filtro a toggle sullo stato di fatturazione, sul modello di StatusLegendTooltip. */
export const BillingStatusLegendTooltip: React.FC = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setIsVisible(false);
      }
    };

    if (isVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isVisible]);

  return (
    <div className="status-flow-tooltip-container">
      <button
        ref={buttonRef}
        type="button"
        className="status-flow-trigger"
        onClick={() => setIsVisible(!isVisible)}
        aria-label={t('billing.legendHelpLabel')}
        aria-expanded={isVisible}
      >
        <span className="material-icons">help_outline</span>
      </button>

      {isVisible && (
        <div
          ref={tooltipRef}
          className="status-flow-tooltip billing-status-legend-tooltip"
          role="tooltip"
        >
          <div className="tooltip-header">{t('billing.legendTitle')}</div>
          <div className="tooltip-content">
            <div className="billing-status-legend-list">
              {BILLING_LEGEND_STATUSES.map((status) => (
                <div key={status} className="billing-status-legend-item">
                  <span className={`billing-status-badge billing-status-badge-${status.toLowerCase().replace('_', '-')}`}>
                    {t(`billing.status.${status}`)}
                  </span>
                  <span className="billing-status-legend-description">{t(`billing.legendDescription.${status}`)}</span>
                </div>
              ))}
              <div className="billing-status-legend-item">
                <span className="billing-status-badge billing-status-badge-none">{t('billing.status.NONE')}</span>
                <span className="billing-status-legend-description">{t('billing.legendDescription.NONE')}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BillingStatusLegendTooltip;
